import { render, staticRenderFns } from "./QQCheckBox.vue?vue&type=template&id=139cabe2&scoped=true&"
import script from "./QQCheckBox.vue?vue&type=script&lang=js&"
export * from "./QQCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./QQCheckBox.vue?vue&type=style&index=0&id=139cabe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139cabe2",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QAvatar,QList,QItem,QIcon,QItemSection,QItemLabel});
